import React, { useEffect, useState } from "react";
import useCoinStore from "../stores/coinStore";
import { WELCOME_EVENT } from "../Services/welcomeBonusService";
import { WELCOME_COPY } from "../utils/hostingCopy";

const WelcomeBonusToast = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => {
      useCoinStore.getState().syncBalance();
      setVisible(true);
    };
    window.addEventListener(WELCOME_EVENT, show);
    return () => window.removeEventListener(WELCOME_EVENT, show);
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    const timer = setTimeout(() => setVisible(false), 9000);
    return () => clearTimeout(timer);
  }, [visible]);

  if (!visible) return null;
  return (
    <div role="status" className="fixed inset-x-4 top-4 z-[70] mx-auto max-w-sm rounded-2xl bg-white p-4 shadow-xl border border-green-200">
      <p className="text-sm font-semibold text-gray-900">{WELCOME_COPY}</p>
      <button type="button" onClick={() => setVisible(false)} className="mt-2 text-xs font-semibold text-red-700">
        Close
      </button>
    </div>
  );
};

export default WelcomeBonusToast;
